/**
 * P&L Statement (BE-10) — real API.
 *
 * The statement is account-based: each section has `lines` ({ account, name, amount }) and a `total`. `basis` defaults
 * to the TC's official basis; the comparison is returned only when `compareFrom` / `compareTo` are sent.
 * Accounting settings hold the official basis (`plBasis`) and Small Business Relief (`sbrElected`).
 */

import ApiService from '../api.service';
import { keysCamelToSnake, unwrapData } from '../../utils/apiConvert';

const clean = (obj) => Object.fromEntries(Object.entries(obj || {}).filter(([, v]) => v !== '' && v !== undefined && v !== null));

export const profitLossService = {
  // params: { from, to, basis, compareFrom, compareTo } — dates as YYYY-MM-DD
  get: async (params) => unwrapData(await ApiService.get('/api/reports/profit-loss', { params: clean(params) })),

  getSettings: async () => unwrapData(await ApiService.get('/api/settings/accounting')),

  // data: { plBasis, sbrElected } — partial update
  updateSettings: async (data) => unwrapData(await ApiService.put('/api/settings/accounting', keysCamelToSnake(clean(data)))),
};

export default profitLossService;
